module.exports = __webpack_public_path__ + "static/media/2025 여름철 물놀이 안전 수칙 및 화재 대피 요령 안내 가정통신문.8d04741e.pdf";